import H2 from '@/components/typography/SecondaryHeading';

import clsx from 'clsx';

type HeadingProps = {
  children: React.ReactNode;
  className?: string;
};

export default function SecondaryHeading({
  children,
  className,
}: HeadingProps) {
  return (
    <H2 className={clsx('text-xl sm:text-2xl mb-3', className)}>{children}</H2>
  );
}
